export const MODULE_NAME = '@pressreader/comments-popups';

export const COMMENTS_DIALOG_NAME = 'comments.dialog';
export const ADD_VIDEO_DIALOG_NAME = 'add.video.dialog';
export const REPORT_USER_DIALOG_NAME = 'report.user.dialog';
export const BLOCKED_USERS_DIALOG_NAME = 'blocked.users.dialog';

export const PAGE_SIZE = 20;
